var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { class: _vm.classes, attrs: { title: _vm.attributeMatch.translation } },
    [
      _vm.isMatch
        ? _c(
            "svg",
            {
              staticClass: "products-item-matching-list-item-icon",
              attrs: {
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M21.5 13L14.1666 20L10.5 16.5",
                  stroke: "#1A542A",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
                  stroke: "#1A542A",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _c(
            "svg",
            {
              staticClass: "products-item-matching-list-item-icon",
              attrs: {
                width: "32",
                height: "32",
                viewBox: "0 0 32 32",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
                  stroke: "black",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M11 16H21",
                  stroke: "black",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.attributeMatch.translation))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }